import { Component, input, computed, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-checkout-actions-layout',
  imports: [],
  templateUrl: './checkout-actions-layout.component.html',
  styleUrl: './checkout-actions-layout.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  encapsulation: ViewEncapsulation.None,
})
export class CheckoutActionsLayoutComponent {
  // Input: Controls layout direction (vertical or horizontal)
  readonly isVertical = input<boolean>(false);

  // Computed: Generate CSS classes based on layout direction
  readonly wrapperCssClasses = computed(() => {
    const baseClass = 'checkout-actions-layout';
    const layoutClass = this.isVertical() ? 'vertical' : 'horizontal';
    return `${baseClass} ${layoutClass}`;
  });
}
